import React from 'react';
import ProductFilterList from 'components/product/ProductFilterList';
import analytics from 'app/utils/analytics';
import DropdownSelect from 'seedly-component-library/dropdown-select';
import useIsMobile from 'app/utils/hooks/useIsMobile';

interface OwnProps {
  options: string[];
  optionsName: { [x: string]: string | JSX.Element };
  isBlock?: boolean;
  onClick: (option: string) => void;
  handleFilterClick: () => void;
}

const makeSortOptions = (
  options: string[],
  optionsName: { [x: string]: string | JSX.Element },
  onClick: (option: string) => void,
) => {
  return options.map(option => {
    if (optionsName) {
      return {
        title: optionsName[option],
        value: optionsName[option],
        onClick: () => onClick(option),
      };
    }
    return { title: option, value: option, onClick: () => onClick(option) };
  });
};

const SortSelect = (props: OwnProps) => {
  const { options, optionsName, onClick, handleFilterClick, isBlock } = props;
  const dropdownSortOptions = makeSortOptions(options, optionsName, onClick);
  const isMobile = useIsMobile();

  return (
    <div className="flex flex-col lg:flex-row lg:justify-between items-center">
      <ProductFilterList onClick={handleFilterClick} />
      <DropdownSelect
        variant="white"
        menuWidthClass="w-full"
        isBlock={isBlock || isMobile}
        items={dropdownSortOptions}
        defaultSelectedItem={dropdownSortOptions[0]}
        handleSelectedItemchange={item => {
          item.selectedItem.onClick();
        }}
        onClick={item => {
          analytics.trackSortingClick({
            key: item.selectedItem.value,
            value: item.selectedItem.title,
          });
        }}
      />
    </div>
  );
};

export default SortSelect;
